import styles from './VitalSliders.module.css';

// Two columns: pressures/HR on the left, respiratory/temp/CVP on the right.
const LEFT_COLUMN = ['HR', 'SpO2', 'NIBP_Sys', 'NIBP_Dia', 'ABP_Sys', 'ABP_Dia'];
const RIGHT_COLUMN = ['EtCO2', 'RR', 'Temp', 'CVP'];

export default function VitalSliders({ store }) {
  const handleInputChange = (vitalName, value) => {
    const num = parseFloat(value);
    if (!isNaN(num)) {
      store.setVitalTarget(vitalName, num);
    }
  };

  const handleIncrement = (vitalName, vital, amount) => {
    const step = vital.unit === '°C' ? 0.1 : 1;
    const newValue = Math.min(vital.max, vital.target + amount * step);
    store.setVitalTarget(vitalName, newValue);
  };

  // Alarm thresholds live inline under each parameter (low = yellow, high = orange).
  const handleAlarmLow = (vitalName, value) => {
    const num = parseFloat(value);
    if (Number.isNaN(num)) return;
    store.setAlarmThresholds(vitalName, { alarmLow: num, alarmHigh: store.vitals[vitalName].alarmHigh });
  };
  const handleAlarmHigh = (vitalName, value) => {
    const num = parseFloat(value);
    if (Number.isNaN(num)) return;
    store.setAlarmThresholds(vitalName, { alarmLow: store.vitals[vitalName].alarmLow, alarmHigh: num });
  };

  const renderVitalRow = (vitalName) => {
    const vital = store.vitals[vitalName];
    if (!vital) return null;

    const displayCurrent =
      vital.current % 1 === 0 ? Math.round(vital.current) : vital.current.toFixed(1);
    const displayTarget = vital.target % 1 === 0 ? Math.round(vital.target) : vital.target.toFixed(1);

    const alarmStep = vital.unit === '°C' ? 0.1 : 1;

    return (
      <div key={vitalName} className={styles.rowWrap}>
        <div className={styles.sliderRow}>
          <div className={styles.label}>{vitalName}</div>
          <div className={styles.values}>
            <span className={styles.current}>
              Current: <span className={styles.value}>{displayCurrent}</span>
            </span>
            <span className={styles.target}>
              Target: <span className={styles.value}>{displayTarget}</span>
            </span>
          </div>
          <div className={styles.inputGroup}>
            <button
              className={styles.decrementBtn}
              onClick={() => handleIncrement(vitalName, vital, -1)}
              title="Decrease"
            >
              −
            </button>
            <input
              type="number"
              min={vital.min}
              max={vital.max}
              step={alarmStep}
              value={displayTarget}
              onChange={(e) => handleInputChange(vitalName, e.target.value)}
              className={styles.numberInput}
            />
            <button
              className={styles.incrementBtn}
              onClick={() => handleIncrement(vitalName, vital, 1)}
              title="Increase"
            >
              +
            </button>
          </div>
          <span className={styles.unit}>{vital.unit}</span>
        </div>

        {/* Alarm thresholds — low (yellow) / high (orange), edited in place */}
        <div className={styles.alarmRow}>
          <span className={styles.alarmTag}>ALARM</span>
          <label className={`${styles.alarmField} ${styles.alarmLow}`}>
            <span className={styles.alarmCaption}>Lo</span>
            <input
              type="number"
              min={vital.min}
              max={vital.alarmHigh}
              step={alarmStep}
              value={vital.alarmLow}
              onChange={(e) => handleAlarmLow(vitalName, e.target.value)}
              className={styles.alarmInput}
              title={`${vitalName} low alarm limit`}
            />
          </label>
          <label className={`${styles.alarmField} ${styles.alarmHigh}`}>
            <span className={styles.alarmCaption}>Hi</span>
            <input
              type="number"
              min={vital.alarmLow}
              max={vital.max}
              step={alarmStep}
              value={vital.alarmHigh}
              onChange={(e) => handleAlarmHigh(vitalName, e.target.value)}
              className={styles.alarmInput}
              title={`${vitalName} high alarm limit`}
            />
          </label>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.slidersContainer}>
      <div className={styles.column}>{LEFT_COLUMN.map(renderVitalRow)}</div>
      <div className={styles.column}>{RIGHT_COLUMN.map(renderVitalRow)}</div>
    </div>
  );
}
